var map = {
	"./added-support-for-gatling.mdx": [
		59149,
		9149
	],
	"./automate-performance-testing-with-jmeter.mdx": [
		14682,
		4682
	],
	"./black-friday-performance-analysis.mdx": [
		96749,
		6749
	],
	"./github-actions-integration.mdx": [
		78916,
		8916
	],
	"./introducing-performance-test-thresholds.mdx": [
		80130,
		130
	],
	"./performance-test-metrics-reporting.mdx": [
		20185,
		185
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 20691;
module.exports = webpackAsyncContext;